/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
var FileInput = require('../../view/uploadImg/uploadImg');
module.exports = nb.define({
    parent: require('./Dialog'),
    slot: {
        content: ['html', [{
            'class': 'prompt-info',
            $html: [{
                'class': 'title',
                $text: nb.bind('titleText')
            }, {
                'class': 'info',
                $text: nb.bind('info')
            }]
        }, {
            'class': 'cancel-cause',
            $html: [{
                'class': 'cancel-title',
                $text: nb.bind('cancelTitle')
            }, {
                'class': 'cancel-list clearfix',
                $type: require('../../view/form/RadioList'),
                $model: 'cancelList'
            }]
        }, {
            'class': 'cancel-title',
            $text: nb.bind('titleText2')
        }, {
            'class': 'cancel-other-reasons',
            tag: 'textarea',
            value: nb.bind('suggest'),
            placeholder: nb.bind('otherReasons') //'您的意见（至少15字,不超过150字）
        }, {
            'class': 'cancel-title',
            $text: nb.bind('titleText3')
        }, {
            'class': 'img-text',
            $text: nb.bind('imgText')
        }, {
            'class': 'upload-img',
            'data-upState': nb.bind('imgUp'),
            $html: {
                $name: 'uploadImg',
                $type: FileInput,
                $model: 'uploadImg'
            }

        }]],
        footer: ['html', [{
            $name: 'cancel-order',
            class: 'btn btn-solid-gold btn-md',
            $text: nb.bind('cancelBtn')
        }, {
            class: 'btn btn-line-gold btn-md uk-modal-close',
            tag: 'button',
            disabled: nb.bind('btnDisabled'),
            $text: nb.bind('closeBtn')
        }]]
    },
    method: {
        init: function () {
            var self = this;

            //点击提交原因
            this.$('cancel-order').on('click', function () {
                self.getModel().set('cancelOrderCause', new Date())
            });

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/returnOrder.js
// module id = 176
// module chunks = 3 8